import { api } from "../client";
import { UserChangelog } from "../schema/UserChangelog";
import { Config } from "../types";

type ApiRequestConfig = Config<UserChangelog[]>;

export const getUserChangelog = async (
  userId: number,
  config?: ApiRequestConfig
) => {
  return api.get<UserChangelog[]>(
    `user_users/${userId}/user_user_histories`,
    config
  );
};
